module.exports = {"530422001":"凤麓街道","530422002":"龙街街道","530422101":"右所镇","530422102":"阳宗镇","530422103":"海口镇","530422104":"九村镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530422.json
// module id = 2567
// module chunks = 0